(function () {
  'use strict';

  if (window.PGHomeUiFixV10) return;
  window.PGHomeUiFixV10 = true;

  var observer = null;
  var stopTimer = null;

  function isCartPage() {
    var body = document.body;
    var path = window.location.pathname || '';

    return /(^|\/)cart(?:\/|$)/.test(path) || Boolean(
      body && (
        body.classList.contains('template-cart') ||
        body.classList.contains('cart')
      )
    );
  }

  function removeFounderContentFromCart() {
    if (!isCartPage()) return;

    var selectors = [
      '.pg-founder-note',
      '.pg-home-founder',
      '[data-pg-home-founder]',
      '[class*="founder-note"]'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function (section) {
      var wrapper = section.closest('.shopify-section');
      var target = wrapper || section;

      if (!target || target.dataset.pgCartFounderRemoved === 'true') return;
      target.dataset.pgCartFounderRemoved = 'true';
      target.remove();
    });
  }

  function stopObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (stopTimer) {
      window.clearTimeout(stopTimer);
      stopTimer = null;
    }
  }

  function startCartCleanup() {
    if (!isCartPage()) return;

    removeFounderContentFromCart();

    [100, 350, 900, 1800, 3500, 6500].forEach(function (delay) {
      window.setTimeout(removeFounderContentFromCart, delay);
    });

    if (window.MutationObserver && document.documentElement) {
      observer = new MutationObserver(removeFounderContentFromCart);
      observer.observe(document.documentElement, { childList: true, subtree: true });
      stopTimer = window.setTimeout(stopObserver, 15000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCartCleanup, { once: true });
  } else {
    startCartCleanup();
  }

  window.addEventListener('pageshow', removeFounderContentFromCart, { passive: true });
})();
